module.exports = require("cli-cursor");


//////////////////
// WEBPACK FOOTER
// external "cli-cursor"
// module id = 16
// module chunks = 0